import { EventType } from '@wix/platform-editor-sdk';
import type { FlowEditorSDK } from '@wix/yoshi-flow-editor';

import { EDITOR_ACTION } from '../../../../constants/editor-actions';
import { openUnifiedManagerPanel } from '../../panels/open-panel';

export const addEditorActionsListeners = async (editorSDK: FlowEditorSDK) => {
  await editorSDK.addEventListener(
    EventType.navBarMainActionClicked,
    async (event) => {
      const { actionId } = event.detail;

      if (actionId === EDITOR_ACTION.OPEN_UNIFIED_MANAGER_PANEL) {
        await openUnifiedManagerPanel(editorSDK, {
          initialTab: 'memberPageTabs',
        });
      }
    },
  );
};
